export default __webpack_public_path__ + "static/media/type4.16a7b27f.svg";